import React from 'react'
import Banner from '../banner/Banner'
import Coinstabel from '../Coinstable/Coinstabel'
const Homepage = () => {
  return (
    <>
     <Banner/>
     <Coinstabel/>
     </>
  )
}

export default Homepage